<template>
  <div class="home">
    <HomeComponents />
  </div>
</template>

<script>
// @ is an alias to /src folder
import HomeComponents from '@/components/HomeComponents.vue'

export default {
  name: 'home',
  components: {
    HomeComponents
  }
}
</script>
